var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-page"},[_c('img',{staticClass:"service-bg",attrs:{"src":require('@/assets/icons/service.png'),"alt":""}}),_c('img',{staticClass:"service-qr",attrs:{"src":"http://mmcb-pub-static.mmcb.top/service-qrcode.jpg","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }